import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App'
import Vuex from 'vuex'
import axios from 'axios'
import store from './store'
import ElementUI from 'element-ui'
import router from './router'
import querystring from 'querystring'
import 'element-ui/lib/theme-chalk/index.css'
import { cookie } from '@/common/js/cookies.js'
// import VueAwesomeSwiper from 'vue-awesome-swiper'
import '../static/public.css'
import VueClipboard from 'vue-clipboard2'

import SlideVerify from "vue-monoplasty-slide-verify";
Vue.use(SlideVerify);
import 'swiper/dist/css/swiper.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)　　
// import style
// If you use Swiper 6.0.0 or higher
// import 'swiper/swiper-bundle.css'

// Vue.use(VueAwesomeSwiper, /* { default options with global component } */)

Vue.use(Vuex);//装在vuex插件
Vue.use(ElementUI);//装载element-ui
Vue.use(VueClipboard);//复制文字插件

// 遍历每个页面的title
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  let token = cookie.get('xyxf_token_qt');
  if (token) {
    axios.defaults.headers.get['token'] = token;
    axios.defaults.headers.post['token'] = token;
  }
  next();

})

// console.log(cookie.get('xyxf_token_qt'))
//POST传参序列化(添加请求拦截器)
axios.interceptors.request.use((config) => {
  //在发送请求之前做某件事
  if (config.method === 'post') {
    config.data = querystring.stringify(config.data);
  }
  // console.log(cookie.get('xyxf_token_qt'))
  // config.headers.token = cookie.get('xyxf_token_qt');
  return config;

}, function (error) {
  return Promise.reject(error);
});
// 添加响应拦截器
axios.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  // console.log(response.data);
  if (response.data.result == 2) {
    setTimeout(() => {
      //登录失效删除token
      cookie.delete('xyxf_token_qt');
      // window.location.href = SOWINURL + 'index/login';
    }, 2000);

  }
  return response;
}, function (error) {
  // 对响应错误做点什么
  return Promise.reject(error);
});
Vue.prototype.$http = axios;

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

const vuex_store = new Vuex.Store({//创建Vuex.Store对象
  state: {
    // versionNum : versionNum,
    user: {},
    tel: null,
    yhsm: null,//是否已实名
    kcId: '',
    autonym: 1,
    // user:{
    //   areaCode:"330000000000",
    //   areaLevel:0,
    //   areaName:"浙江省",
    //   idCard:"sowin",
    //   roleLevel:1,
    //   userName:"sowin",
    // },
  },
  mutations: {
    upAutonym(state, num) {
      state.autonym = num;
    }
  },
})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  router,
  store: vuex_store, //将vuex注入到vue
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js